// Config option kỳ báo cáo quyết toán
export default {
  January: 1, // tháng 1
  February: 2, // tháng 2
  March: 3, // tháng 3
  April: 4, // tháng 4
  May: 5, // tháng 5
  June: 6, // tháng 6
  July: 7, // tháng 7
  August: 8, // tháng 8
  September: 9, // tháng 9
  October: 10, // tháng 10
  November: 11, // tháng 11
  December: 12, // tháng 12

  QuarterI: 101, // Quý I
  QuarterII: 102, // Quý II
  QuarterIII: 103, // Quý III
  QuarterIV: 104, // Quý IV

  FirtsHalfYear: 201, // 6 tháng đầu năm
  SecondHalfYear: 202, // 6 tháng cuối năm
  Year: 203, // Cả năm
};
